var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FlexContainer',[_c('div',{staticClass:"lgooArea"},[_c('img',{staticClass:"jobrainbowLogo",attrs:{"src":require("assets/svg/logo-h-c-w.svg"),"alt":"jobrainbow"}}),_vm._v(" "),_c('img',{staticClass:"mainLogo",attrs:{"src":require("assets/svg/main_logo_b.svg"),"alt":"セクシュアリティ診断"}})]),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }